import { useParams } from "react-router-dom";
import { UserGifList } from "components/feed/UserGifList";
import { MyGifList } from "components/feed/MyGifList";
import { CreatorInfo } from "components/profile/CreatorInfo";
import { useUserInfo } from "queries";
import { useSelector } from "react-redux";
import { IAppState } from "store/app-state";
import { useEffect } from "react";
import { metrics } from "utils/metrics";
import { WithSideAds } from "../../components/ads";
import { ProfilePageSkyscraperEnum } from "../../components/ads/config/units/profilePageSkyscraper";
import { PageNotFound, REMOVED_USER, NOT_FOUND } from "components/page-not-found/PageNotFound";
import "./style/UserPage.scss";

const validateUserId = (id: string | undefined): string => {
  if (id === undefined) {
    throw new Error("user id not specified");
  }

  return id;
};

export const UserPage = () => {
  const { id } = useParams();
  const query = useUserInfo(validateUserId(id));
  const currentUser = useSelector((state: IAppState) => state.user.currentUser);
  const isUserLoggedIn = !!Object.entries(currentUser).length;

  useEffect(() => {
    if (isUserLoggedIn) {
      metrics.sendProfileView({ userName: currentUser.username });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  if (query.isLoading) {
    return null;
  }

  if (query.isError) {
    // @ts-ignore
    const status = query.error?.response?.status;

    // eslint-disable-next-line no-magic-numbers
    if (status === 410) {
      return <PageNotFound pageType={REMOVED_USER} />;
    }
    // eslint-disable-next-line no-magic-numbers
    if (status === 404) {
      return <PageNotFound pageType={NOT_FOUND} />;
    }
  }

  const isMyself = currentUser.username === query?.data?.username;

  return (
    <WithSideAds
      leftAds={[
        ProfilePageSkyscraperEnum.ProfilePageSkyscraperL1,
      ]}
      rightAds={[
        ProfilePageSkyscraperEnum.ProfilePageSkyscraperR1,
      ]}
    >
      <div className="wide page creatorPage">
        <CreatorInfo myself={isMyself} user={query.data} />
        {query.data && !isMyself && <UserGifList id={query.data.username} />}
        {query.data && isMyself && <MyGifList id={query.data.username} />}
      </div>
    </WithSideAds>
  );
};
